import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import styled from 'styled-components';
import logger from '../../utils/logger';

// Styles pour le loader
const CallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

const LoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: ${({ theme }) => theme.colors.primary};
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Message = styled.p`
  margin-top: 20px;
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
`;

/**
 * Composant pour gérer la redirection après confirmation d'email
 * Échange le code d'authentification pour une session et redirige vers l'application
 */
const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState<string>('Authentification en cours...');
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Récupérer l'URL complète
        const fullUrl = window.location.href;
        logger.debug('URL de callback:', fullUrl);
        
        // Échanger le code pour une session
        const { error } = await supabase.auth.exchangeCodeForSession(fullUrl);
        
        if (error) {
          logger.error('Erreur lors de l\'échange du code:', error);
          setMessage('Erreur d\'authentification. Veuillez réessayer.');
          setError(true);
          // Rediriger vers la page de connexion après 3 secondes
          setTimeout(() => navigate('/login'), 3000);
          return;
        }
        
        logger.info('Session établie avec succès');
        setMessage('Authentification réussie. Redirection...');
        
        // Rediriger vers la page d'accueil
        setTimeout(() => navigate('/'), 1000);
      } catch (err) {
        logger.error('Exception lors du traitement du callback:', err);
        setMessage('Une erreur est survenue. Redirection vers la page de connexion...');
        setError(true);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <CallbackContainer>
      <LoadingSpinner />
      <Message style={{ color: error ? 'red' : undefined }}>{message}</Message>
    </CallbackContainer>
  );
};

export default AuthCallback;

